import React from 'react'

export const content = {
  chatTitle: 'Chat with us',
  chatCtaPrompt:
    'Click this icon to launch a web chat in the bottom right of your screen.',
  chatOpeningHours: (
    <span>
      Chat to our SMARTY bot 24/7, or our customer support team are available
      daily from 8am – 8pm to assist.
    </span>
  ),
  waitTimesAndOutsideOpeningTimes:
    'Our wait times may vary depending on how busy we are. Our open days exclude Christmas Day and New Years Day. If you need help outside of these days or outside of our opening hours, you can still submit your question via web chat and we’ll reply as soon as possible.',
  emailTitle: 'Or send us an email',
  emailResponseTime: 'The team typically reply in a day.',
  ctaText: 'Email us',
  dataItemName: 'customer-dedicated-email',
  emailText:
    'Contacting the web chat team is the quickest way to get a response, but if you would like, you can also send us an email. The team typically reply in a day by email.',
}
